import React from 'react';

export const Content = props => {
    return (
        <section className="application-content">
            { props.children }
        </section>
    );
}
 
export default Content;